import { React, useEffect, useState } from "react";
import { Row, Col, Form, Button, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { useGetAdminLogsQuery } from "../slices/adminSlice";
import { getCurrentDate, getCurrentTime } from "../utils/getCurrentDate";
import { setCredentials } from "../slices/authSlice";

const AdminLogs = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const [startDate, setStartDate] = useState(getCurrentDate());

  const [endDate, setEndDate] = useState(getCurrentDate());

  const [getApiQuery, setGetApiQuery] = useState(
    `createdAt[gte]=${startDate}&createdAt[lte]=${endDate}T23:59:59.000Z&sort=-createdAt`
  );

  const dispatch = useDispatch();

  let {
    data: adminLogs,
    isLoading,
    refetch,
    error,
  } = useGetAdminLogsQuery({
    token: userInfo?.token,
    query: getApiQuery,
  });

  const [adminLogsList, setAdminLogsList] = useState(
    isLoading ? [] : adminLogs ? adminLogs : []
  );

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    const logs = isLoading ? [] : adminLogs ? adminLogs : [];

    setAdminLogsList(logs);
  }, [isLoading, adminLogs]);

  const handleGetUsers = async () => {
    if (startDate > getCurrentDate())
      toast.error("Start date can not be greater than today");
    else if (startDate > endDate)
      toast.error("Start date can not be greater than End date");
    else {
      if (endDate?.split("T")[0] > getCurrentDate())
        setEndDate(getCurrentDate() + getCurrentTime());
      setGetApiQuery(
        `createdAt[gte]=${startDate}&createdAt[lte]=${endDate}T23:59:59.000Z&sort=-createdAt`
      );
      dispatch(
        setCredentials({
          ...userInfo,
          paymentStartDate: startDate,
          paymentEndDate: endDate,
        })
      );
    }
  };

  return (
    <>
      <strong>Admin Logs</strong>

      <Row
        className="mb-1"
        style={{
          justifyContent: "center",
          margin: "auto",
          width: "95%",
          alignItems: "center",
        }}
      >
        <Col xs={6} md="auto" sm={6}>
          <Form.Group controlId="visitorMobile">
            <Form.Control
              type="date"
              placeholder="2023-11-23"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            ></Form.Control>{" "}
          </Form.Group>
        </Col>
        <Col xs={6} md="auto" sm={6}>
          <Form.Group controlId="visitorMobile">
            <Form.Control
              type="date"
              placeholder="2023-11-27"
              value={endDate?.split("T")[0]}
              onChange={(e) => setEndDate(e.target.value)}
            ></Form.Control>{" "}
          </Form.Group>
        </Col>
        <Col xs={12} md="auto" sm={6} className="d-flex justify-content-center">
          <Form.Group className="my-1" controlId="gymType">
            <Button onClick={handleGetUsers}>Get Logs</Button>
          </Form.Group>
        </Col>
        <Col xs={12} md="auto" sm={6} className="d-flex justify-content-center">
          <span style={{ color: "green" }}>
            <strong> Total : {adminLogsList?.length}</strong>
          </span>
        </Col>
      </Row>

      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message>{error.data.error}</Message>
      ) : (
        <div>
          <Table
            striped
            bordered
            hover
            responsive="sm"
            style={{ marginTop: "2rem" }}
          >
            <thead>
              <tr key="table-header">
                <th>Type</th>
                <th>Activity</th>
                <th>Admin</th>
                <th>Date</th>
                <th>Time</th>
              </tr>
            </thead>
            {adminLogsList ? (
              <tbody>
                {adminLogsList.map((adminLog) => (
                  <tr key={adminLog._id}>
                    <td>{adminLog.activityType}</td>
                    <td style={{ minWidth: "15rem" }}>
                      {adminLog.adminActivity}
                    </td>
                    <td>{adminLog.adminId}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {new Date(adminLog.createdAt)?.toISOString().slice(0, 10)}
                    </td>
                    <td>
                      {new Date(adminLog.createdAt)?.toLocaleTimeString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <Message>No Gyms Available</Message>
            )}
          </Table>
        </div>
      )}
    </>
  );
};

export default AdminLogs;
